export default __webpack_public_path__ + "static/media/fontawesome-webfont.7f77840e.eot";